import { CLINICAL_ANALYSIS_ACTIONS } from 'constants/Actions/ClinicalAnalysis';

// Estado inicial del reducer
const aInitialState = {
    // Manejo de la lista de análisis clínicos
    aClinicalAnalysis: [],
    // Manejo de la lista de análisis clínicos para un individuo en particular
    aClinicalAnalysisIndividual: [],
    // Manejo de la lista de análisis clínicos en bandeja de entrada
    aClinicalAnalysisInbox: [],
    // Manejo de la lista de análisis clínicos en bandeja de salida
    aClinicalAnalysisOutbox: [],
    // Manejo del total de páginas para el listado de análisis clínicos
    nTotalPages: 0,
    // Manejo del total de páginas para el listado de análisis clínicos en bandeja de entrada
    nTotalPagesInbox: 0,
    // Manejo del total de páginas para el listado de análisis clínicos en bandeja de salida
    nTotalPagesOutbox: 0,
    // Manejo del estudio de paternidad al ver su detalle
    oClinicalAnalysis: null,
    aIndividuals: [],
    aSamples: [],
    aAttachments: [],
    // Manejo de la traza de un estudio de paternidad al ver su detalle
    aTraceabilities: [],
    // Manejo de errores y acciones satifactorias
    bIsError: false,
    bIsSuccess: false,
    bImportSuccess: false,
    // Manejo de una nueva inserción
    nNewId: null,
    // Manejo de la toma de una ficha de análisis clínico
    sFile: null,
    // Manejo de registros que serán ingresados mediante una planilla
    aDataImport: [],
    // id del reporte generado
    nNewReportId: null
}
/**
 * Reducer que sera utilizado para controlar los datos referidos a los estudios de patarnidad del sistema.
 * 
 * @param {Array} aState Estado, si no recibe datos se setea el estado inicial
 * @param {object} oAction Action que es ejecutada
 * 
 * @returns {Array} Retorna un array que sera seteado en el estado del reducer
 * 
 * @author Leandro Curbelo 
 */
export const ClinicalAnalysisReducer = (aState = aInitialState, oAction) => {
    switch (oAction.type) {
        case CLINICAL_ANALYSIS_ACTIONS.CREATE_REPORT:
            return { ...aState, nNewReportId: oAction.data, bIsSuccess: true}
        case CLINICAL_ANALYSIS_ACTIONS.GET:
            return { ...aState, aClinicalAnalysis: oAction.data.data, nTotalPages: oAction.data.pages };
        case CLINICAL_ANALYSIS_ACTIONS.GET_INDIVIDUAL:
            return { ...aState, aClinicalAnalysisIndividual: oAction.data };
        case CLINICAL_ANALYSIS_ACTIONS.GET_INBOX:
            return { ...aState, aClinicalAnalysisInbox: oAction.data.data, nTotalPagesInbox: oAction.data.pages };
        case CLINICAL_ANALYSIS_ACTIONS.GET_OUTBOX:
            return { ...aState, aClinicalAnalysisOutbox: oAction.data.data, nTotalPagesOutbox: oAction.data.pages };
        case CLINICAL_ANALYSIS_ACTIONS.GET_SHEET:
            return { ...aState, sFile: oAction.data };
        case CLINICAL_ANALYSIS_ACTIONS.FIND:
            return { ...aState, oClinicalAnalysis: oAction.data };
        case CLINICAL_ANALYSIS_ACTIONS.FIND_SAMPLES:
            return { ...aState, aSamples: oAction.data };
        case CLINICAL_ANALYSIS_ACTIONS.FIND_ATTACHMENTS:
            return { ...aState, aAttachments: oAction.data };
        case CLINICAL_ANALYSIS_ACTIONS.TRACEABILITY:
            return { ...aState, aTraceabilities: oAction.data };
        case CLINICAL_ANALYSIS_ACTIONS.SUCCESS:
            return { ...aState, bIsSuccess: true, nNewId: oAction.data };
        case CLINICAL_ANALYSIS_ACTIONS.SUCCESS_UPLOAD_FILE:
            return { ...aState, bImportSuccess: true, aDataImport: oAction.data };
        case CLINICAL_ANALYSIS_ACTIONS.UPDATE:
            return { ...aState, bIsSuccess: true };
        case CLINICAL_ANALYSIS_ACTIONS.ERROR:
            return { ...aState, bIsError: true };
        case CLINICAL_ANALYSIS_ACTIONS.RESET:
            return { ...aState, bIsError: false, bIsSuccess: false, nNewId: null, nNewReportId: null };
        case CLINICAL_ANALYSIS_ACTIONS.CLEAN:
            return { ...aState, 
                bIsError: false, 
                bIsSuccess: false, 
                nNewId: null, 
                oClinicalAnalysis: null, 
                aIndividuals: [], 
                aSamples: [], 
                aAttachments: [], 
                aTraceabilities: [], 
                sFile: null, 
                nNewReportId: null 
            };
        case CLINICAL_ANALYSIS_ACTIONS.CLEAN_IMPORTS:
            return { ...aState, bImportSuccess: false, aDataImport: [] };
        default:
            return aState;
    }
}
